import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	Interactive,
	useVideoConfig,
	useCurrentFrame,
} from 'remotion';

const StudioLevelsCapture = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(157 / 30) * fps}
			style={{
				width: 1248,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/levels-input-black-df5a4b6fb024.mp4"
				muted
				durationInFrames={(157 / 30) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[2, 4, 5, 25, 113],
					['auto', 'custom', 'auto', 'default', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, e-resize'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 35, 95, 143, 146],
						[
							3.628739332014293, 3.265865398812864, 3.628739332014293,
							3.265865398812864, 3.628739332014293,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							2, 3, 4, 5, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 42, 43, 44, 45, 46, 47, 48,
							49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64,
							65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
							81, 82, 83, 91, 92, 93, 94, 95, 96, 97, 105, 106, 107, 108, 109,
							110, 111, 112, 113, 114, 115, 116, 117, 134, 135, 136, 137, 138,
							139, 140,
						],
						[
							'-1579.6072409414405px 3182.673714673833px',
							'-1567.6437409562059px 3154.6218586658006px',
							'-953.7205799840534px 2328.0772524584354px',
							'87.67090925198595px 980.3124354014707px',
							'87.67090925198595px 980.3124354014707px',
							'288.6406992883088px 777.2731299648584px',
							'288.6406992883088px 777.2731299648584px',
							'280.95797773380974px 776.7344889702625px',
							'248.5544694799634px 776.7344889702625px',
							'156.6169565602575px 777.1313823347016px',
							'98.61382630009155px 784.0203171603225px',
							'74.43168059534004px 789.3216785281871px',
							'71.83769896347046px 789.4350766323125px',
							'68.3223577355816px 787.1245902607566px',
							'66.89070667099784px 781.4546850544842px',
							'64.35342409119097px 773.9420606561735px',
							'63.687210229453974px 769.9731270117828px',
							'63.687210229453974px 766.3443876797685px',
							'64.93458937483389px 756.8189469332309px',
							'67.86876531907983px 748.4841862800106px',
							'67.86876531907983px 748.4841862800106px',
							'72.71653427044266px 733.4589374833889px',
							'73.46779671027375px 730.3830139089862px',
							'74.6868263296223px 726.0313616631722px',
							'75.04119540501432px 724.0327200779612px',
							'75.04119540501432px 723.8342733957417px',
							'75.04119540501432px 723.8342733957417px',
							'76.20352597230016px 723.8342733957417px',
							'77.1248855683194px 723.8342733957417px',
							'85.2611995393202px 723.4657295573339px',
							'85.2611995393202px 723.4657295573339px',
							'92.3627558101763px 723.4657295573339px',
							'94.8008150488734px 723.4657295573339px',
							'105.48858636269675px 723.4657295573339px',
							'118.21752355077814px 723.4657295573339px',
							'118.21752355077814px 723.4657295573339px',
							'133.04432566518028px 723.4657295573339px',
							'138.7284056344683px 723.4657295573339px',
							'154.3348197147329px 723.8767976847887px',
							'159.8771520538641px 723.9901957889142px',
							'162.3010365295455px 724.1461181820866px',
							'173.59832265304314px 724.1461181820866px',
							'173.59832265304314px 724.1461181820866px',
							'178.30434397424918px 724.4579629684316px',
							'186.04376458081092px 724.4579629684316px',
							'186.04376458081092px 724.4579629684316px',
							'195.62590437941117px 725.2092254082627px',
							'201.09736290346396px 725.2092254082627px',
							'204.41425744913326px 725.3509730384195px',
							'212.87659096949474px 725.6628178247645px',
							'212.87659096949474px 725.6628178247645px',
							'219.49620529781768px 726.0597111892035px',
							'228.4121312346809px 726.9527212591914px',
							'228.4121312346809px 726.9527212591914px',
							'234.3513569382512px 727.151167941411px',
							'237.7391252989989px 727.151167941411px',
							'239.2983492307238px 727.151167941411px',
							'243.63582671352214px 727.151167941411px',
							'243.63582671352214px 727.151167941411px',
							'246.05971118920357px 727.151167941411px',
							'251.24767445294273px 727.151167941411px',
							'252.49505359832264px 727.151167941411px',
							'258.3775802498302px 727.151167941411px',
							'264.3451554794318px 727.151167941411px',
							'265.6492336768745px 727.151167941411px',
							'266.3579718276585px 727.151167941411px',
							'267.2793314236778px 727.151167941411px',
							'267.74709860319524px 727.151167941411px',
							'267.74709860319524px 727.151167941411px',
							'267.1942828455837px 727.151167941411px',
							'267.1942828455837px 727.151167941411px',
							'266.6414670879721px 727.1795174674423px',
							'266.2729232495644px 728.0016537223519px',
							'266.2729232495644px 729.192333815669px',
							'266.2729232495644px 729.2490328677318px',
							'266.2729232495644px 729.2490328677318px',
							'266.2729232495644px 729.7593243362962px',
							'266.2729232495644px 729.7593243362962px',
							'266.2729232495644px 729.1214600005906px',
							'266.1311756194076px 727.151167941411px',
							'264.7420488438709px 724.7839825177923px',
							'260.94321235566844px 722.9129137997224px',
							'243.66417623955348px 724.7839825177923px',
							'191.86959218025572px 764.3032218055105px',
							'191.86959218025572px 764.3032218055105px',
							'-536.7699258778017px 1675.3861146383958px',
							'-1237.357587927827px 2635.7121341877564px',
							'-1573.2569471104155px 3283.215308744057px',
							'-1573.2569471104155px 3283.215308744057px',
							'-1653.7412515134513px 3351.8636860289994px',
							'-1620.090364114225px 3304.7751232909077px',
							'-1620.090364114225px 3304.7751232909077px',
							'-1574.348403862623px 3241.2154859285947px',
							'-1571.6977231786907px 3236.0133479018396px',
							'-1570.5779169004518px 3234.1139296577385px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const StudioLevelsContent = () => {
	return (
		<AbsoluteFill style={{backgroundColor: '#1f2427', overflow: 'hidden'}}>
			<Interactive.Div
				name="Levels input-black adjustment - close-up"
				style={{
					position: 'absolute',
					width: 1248,
					height: 1440,
					left: '50%',
					top: '60%',
					translate: '-481.1px -398.9px',
					transformOrigin: '624px 650px',
					rotate: '-0.087326 0.991103 -0.10044 35.969469deg',
					scale: 1.439,
				}}
			>
				<StudioLevelsCapture />
			</Interactive.Div>
		</AbsoluteFill>
	);
};

export const StudioLevelsComposition = Interactive.create({
	Component: StudioLevelsContent,
	layout: 'absolute-fill',
	schema: {},
});
